<template>
  <div :style="`background-color: var(--c-${vars.backgroundColor})`">
    <div
      class="tw-grid tw-w-full tw-grid-cols-12 tw-grid-rows-1 tw-items-center tw-p-7"
      :style="`color: var(--c-${vars.textColor})`"
      style="border-radius: var(--rounded)"
    >
      <MotionGroup preset="fadeVisible" is="div" :duration="800" :class="['tw-order-2 tw-col-span-full']">
        <div class="tw-mb-4 tw-uppercase">
          <h3>{{ vars.titleText }}</h3>
        </div>
        <div v-if="vars.landscapePhotoImage" class="tw-relative tw-my-4">
          <LibraryImage
            :src="vars.landscapePhotoImage"
            :h-ratio="11"
            :w-ratio="21"
            class="tw-overflow-hidden tw-rounded-[var(--rounded)]"
          />
        </div>

        <div v-if="vars.portraitPhotoImage" class="tw-relative tw-my-4">
          <LibraryImage
            :src="vars.portraitPhotoImage"
            :h-ratio="5"
            :w-ratio="4"
            class="tw-overflow-hidden tw-rounded-[var(--rounded)]"
          />
        </div>

        <div v-if="vars.videoUrl" class="tw-relative tw-my-4">
          <LibraryIframe
            class="tw-h-full tw-w-full"
            style="border-radius: var(--rounded)"
            :h-ratio="10"
            :w-ratio="16"
            :src="vars.videoUrl"
          />
        </div>

        <div class="tw-flex tw-flex-col tw-gap-3">
          <p
            v-for="(description, index) in descriptions"
            :key="`contentbox-description-${index}`"
            class="tw-text-left"
            :style="`color: var(--c-${vars.textColor})`"
          >
            {{ description.description }}
          </p>
        </div>
        <div class="tw-mt-8 tw-flex tw-flex-wrap tw-gap-3">
          <nuxt-link
            v-for="(button, index) in buttons"
            :key="`contentbox-button-${index}`"
            :external="true"
            :to="button.link"
            :class="`n-${button.type} tw-w-full tw-text-center md:tw-w-auto`"
          >
            {{ button.label }}
          </nuxt-link>
        </div>
      </MotionGroup>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';

export default defineNuxtComponent({
  name: 'SmallBox',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
      isVisible: false,
      plainText: '',
    };
  },

  computed: {
    descriptions() {
      return this.groupedVariables.descriptions;
    },
    buttons() {
      return this.groupedVariables.buttons;
    },

    ...mapState(useWebsiteStore, ['sidebarComponents']),
  },
});
</script>
